import React from 'react';  // eslint-disable-line

const MediaLogo = (props) => {
    return (
        <svg width="64" height="56" viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg">
            <title>Shape</title>
            <defs>
                <linearGradient id="youtube-a" x1="49.98%" x2="49.98%" y1="0%" y2="100.03%">
                    <stop offset="0%" stopColor="#E52D27" />
                    <stop offset="100%" stopColor="#BF171D" />
                </linearGradient>
                <linearGradient id="podcast-a" x1="50%" x2="50%" y1="2.179%" y2="97.818%">
                    <stop offset="0%" stopColor="#D394F2" />
                    <stop offset="100%" stopColor="#936BFF" />
                </linearGradient>
            </defs>

            <path d={props.SVGIconPath} fillRule={props.SVGIconFillRule} fill={props.SVGIconFill} />

        </svg>
    );
};

export default MediaLogo;
